<template>
    <div>
        <div class="addmember">
            <span class="mbtb">办理会员卡</span>
        </div>
        <div style="width: 90%;margin: auto;margin-top: 30px;">
            <div class="bkmb">
                <span style="line-height: 25px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{member.memberName}}</span>
                <span style="width: 30%;line-height: 25px;margin-left: 8px">{{ member.phone }}</span>
            </div>
            <div class="cz-cards">
                <span class="cz-cards-bt">选择会员卡</span>
                <div class="cz-card">
                    <el-radio-group v-model="cardId" @change="setCard(cardId)">
                        <el-radio :label="item.id" class="radioitem" v-for="item in cards">
                            <div style="display: flex;flex-direction: row;justify-content: space-between;width: 150px">
                                <span>{{item.cardName}}</span>
                                <span>¥ {{item.openAmount}}</span>
                            </div>
                        </el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="cz-cards">
                <div class="card-je">
                    <span>开卡金额</span>
                    <el-input v-model="totalAmount" size="small" :disabled="card.changeAmount==1"
                              placeholder="请输入开卡金额" class="ki"></el-input>
                    <div v-if="card&&card.id">
                        <span class="xuanzebtn" @click="setEmp">选择+</span>
                    </div>
                </div>
                <div class="card-je">
                    <span>赠送金额</span>
                    <el-input v-model="card.giveMoney" size="small" placeholder="请输入赠送金额" class="ki"></el-input>
                </div>
            </div>
            <div class="card-emps" v-if="this.emps.length>0">
                <div class="card-emp-bt">
                    <span>员工名称</span>
                    <span style="padding-left: 17px">业绩</span>
                </div>
                <div class="card-emp" v-for="item in this.emps">
                    <span>{{item.empName}}</span>
                    <el-input v-model="item.amount" size="mini" style="width: 50%;"></el-input>
                </div>
            </div>
        </div>
        <div class="jiesuan-btn">
            <van-button type="default" class="jiesuanbtn" @click="jiesuanbk()">结算</van-button>
        </div>
        <van-popup v-model="empShow" position="bottom" closeable lock-scroll overlay>
            <div>
            <span style="display: block;font-size: 15px;text-align: center;height: 45px;line-height: 45px;border-bottom: #e5e5e5 solid 1px">选择员工</span>
            <div class="fw-gw-emps">
                <div class="emp-gw" v-if="fEmps.length>0">
                    <span class="gw">{{fName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" (emp,index) in fEmps">
                            <span class="empname" :class="{hui: emp.check}"
                                  @click="setEmps(emp,1)">{{emp.nickName}}</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="sEmps.length>0">
                    <span class="gw">{{sName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" emp in sEmps">
                            <span class="empname" :class="{hui: emp.check}"
                                  @click="setEmps(emp,2)">{{emp.nickName}}</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="tEmps.length>0">
                    <span class="gw">{{tName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" emp in tEmps">
                            <span class="empname" :class="{hui: emp.check}"
                                  @click="setEmps(emp,3)">{{emp.nickName}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div style="width: 100%;height: 32px;font-size: 18px;background-color: #2b94ff;text-align: center;color: #ffffff;line-height: 32px"
                 @click="setData">
                确定
            </div>
            </div>
        </van-popup>
        <van-popup v-model="jsShow" position="bottom" lock-scroll overlay closeable :close-on-click-overlay="false"
                   style="height: 50%;">
            <div class="addmember">
                <span class="mbtb">结算</span>
            </div>
            <div style="padding-bottom: 40px">
                <div class="jisuanje">
                    <span>结算金额</span>
                    <div style="color: red">
                        <span style="font-size: 10px">¥</span>
                        <span style="font-size: 20px">{{totalAmount}}</span>
                    </div>
                </div>
                <div class="jisuanje">
                    <div class="mb-sex">
                        <el-radio-group v-model="radio" style="margin-top: 7px;">
                            <el-radio :label="1">开单</el-radio>
                            <el-radio :label="2" style="margin-left: -10px" v-if="bdqx">补单</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="srdate2" v-if="radio==2" @click="toShiJian('2')">{{kdDate}}</div>
                </div>
                <div class="jisuanfs">
                    <span>结算方式</span>
                    <van-radio-group v-model="payType" style="margin-top: 10px">
                        <van-radio :name="item.value" checked-color="#07c160" class="radio-btn"
                                   v-for="item in payTypes">{{item.name}}
                        </van-radio>
                    </van-radio-group>
                </div>
            </div>
            <div class="jiesuan-btn">
                <van-button type="default" :loading="isDisabled" class="jiesuanbtn" @click="jiesuan()">结算</van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie} from "../../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                deptId: '',
                token: '',

                totalAmount: 0,
                member: {},
                cardId: '',
                card: {},
                cards: [],


                item: {},
                fEmps: [],
                sEmps: [],
                tEmps: [],
                fName: '',
                sName: '',
                tName: '',
                emps:[],
                empShow:false,

                radio: 1,
                kdDate: '请选择日期',
                jsShow: false,
                payTypes: [
                    {'name': '现金', 'value': 2},
                    // {'name': '微信', 'value': 3},
                    // {'name': '支付宝', 'value': 4},
                ],
                payType: 2,
                isDisabled: false,
                qxs:['bdqx'],
                bdqx:false,
            };
        },
        props:{
            memberId:String
        },
        async created() {
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.getPermissionList()
            this.getCards()
            this.getMemberInfo()
            this.getFwEmps()
            this.getDept()
        },
        methods: {
            async getPermissionList() {
                let data = {
                    token: this.token,
                    qxs:JSON.stringify(this.qxs)
                }
                let res = await this.$post("/fw/getPermissionList", data)
                if (res.permissionList.length > 0) {
                    this.permissionList = res.permissionList
                    if (this.permissionList.indexOf('bdqx') > -1) {
                        this.bdqx = true
                    }
                }
            },
            async getDept() {
                let res = await this.$get("/fw/getFwDeptInfo", {id: this.deptId});
                if (res.dept.isSqb!=null){
                    if (res.dept.isSqb==1){
                        this.payTypes= [
                            {'name': '现金', 'value': 2},
                            {'name': '微信', 'value': 3},
                            {'name': '支付宝', 'value': 4},
                        ]
                    }
                }
            },
            async getCards() {
                let data = {
                    deptId: this.deptId
                }
                let res = await this.$get("/fw/getFwCardList", data);
                this.cards = res.cards
            },

            async getMemberInfo() {
                let data = {
                    memberId: this.memberId,
                }
                let res = await this.$get("/fw/getFwMember", data)
                this.member = res.member
            },

            async getFwEmps() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwEmps", data)
                this.fEmps = res.fEmps;
                this.sEmps = res.sEmps;
                this.tEmps = res.tEmps;
                this.fName = res.fName;
                this.sName = res.sName;
                this.tName = res.tName;
            },
            setEmp() {
                this.empShow = true
            },

            //设置员工
            setEmps(item, type) {
                let amount = 0
                    if (this.emps.length == 0) {
                        amount = this.card.openAmount
                    }
                if (!item.check) {
                        this.emps.push({
                            empId: item.id,
                            empName: item.nickName,
                            amount: amount,
                            station: type,
                        })
                } else {
                    let index = this.emps.findIndex(it => it.empId == item.id);
                    this.emps.splice(index, 1)
                }
                item.check = !item.check
            },

            setData() {
                this.card.emps = this.emps
                this.empShow = false
            },

            jiesuan() {
                this.isDisabled = true
                this.saveMemberCard()
            },

            jiesuanbk() {
                if (this.card && this.card.id) {
                    if (this.emps.length > 0) {
                        let yj = 0
                        this.emps.forEach(item => {
                            yj = parseInt(yj) + parseInt(item.amount)
                        })
                        if (yj > this.card.openAmount) {
                            this.$notify({type: 'danger', message: '员工业绩总和不能大于办卡价格'});
                            return;
                        }
                    }
                    this.isDisabled = false
                    this.jsShow = true
                } else {
                    this.$notify({type: 'danger', message: '请先选择要办理的会员卡'});
                }
            },

            async saveMemberCard() {
                this.card.emps = JSON.stringify(this.emps)
                this.card.payType = this.payType
                this.card.cardId = this.card.id
                this.card.total = this.totalAmount
                this.card.openAmount = this.totalAmount
                this.card.token = this.token
                this.card.kdType = this.radio
                this.card.kdDate = this.kdDate
                this.card.memberId = this.member.id
                this.card.orderSex = this.member.sex
                let res = await this.$post("/sw/saveMemberCard", this.card);
                if (res.code == 200) {
                    this.isDisabled = false
                    this.close()
                    this.jsShow = false
                    this.$notify({type: 'success', message: '办卡成功'});
                } else {
                    this.isDisabled = false
                    this.$notify({type: 'danger', message: res.message});
                }
            },
            close(){
              this.$emit('gbBk')
            },
            setCard(cardId) {
                this.cards.forEach(item => {
                    if (item.id == cardId) {
                        this.card = JSON.parse(JSON.stringify(item))
                    }
                })
                if (this.card && this.card.id) {
                    this.totalAmount = this.card.openAmount
                }
            },
            toShiJian(type) {
                this.dateType = type
                this.sjShow = true
            },
            guanbijs() {
                this.jsShow = false
            },
        },
    };
</script>

<style lang="scss" scoped>

   .cc-btn{
       display: block;
       text-align: center;
       font-size: 15px;height: 30px;
       line-height: 30px;
       color: #ffffff;
       margin: 8px 0;
   }
    .members {
        display: flex;
        flex-direction: column;
        border-top: #EEEEEE solid 1px;
        padding: 10px;
    }

    /deep/ .el-card__header {
        padding: 10px;
        border-bottom: 0.02667rem solid #EBEEF5;
        box-sizing: border-box;
        font-size: 13px;
    }

    /deep/ .el-card__body {
        padding: 10px;
    }


    .srdate2 {
        display: block;
        width: 100px;
        line-height: 45px;
        text-align: right;
    }

    .ki {
        width: 60%;
    }

    .mb-sex {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 40px;
    }

    ::v-deep .el-input .el-input__inner {
        border-color: #ffffff !important;
        border-radius: 0px;
    }

    ::v-deep .el-input.is-disabled .el-input__inner {
        background-color: #ffffff;
        cursor: not-allowed;
    }

    .touxiang {
        height: 25px;
        width: 25px;
        float: left;
    }

    .bkmb {
        display: flex;
        flex-direction: row;
        height: 25px;
        font-size: 12px;
    }

    .cz-cards {
        margin-top: 30px;
    }

    .cz-cards-bt {
        display: block;
        font-size: 13px;
        height: 28px;
        line-height: 28px;
    }

    .cz-card {
        padding-left: 10px;
    }

    .radioitem {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 28px;
        line-height: 28px;
    }

    .card-je {
        display: flex;
        flex-direction: row;
        border-bottom: #EEEEEE solid 1px;
        font-size: 13px;
        height: 45px;
        line-height: 55px;
    }


    .xuanzebtn {
        margin-left: 10px;
        color: #cccccc;
        cursor: pointer;
        padding: 1px 5px;
        font-size: 11px;
        border: #dddddd solid 1px;
    }

    .jiesuan-btn {
        width: 100%;
        position: fixed;
        bottom: 0px;
    }

    .jiesuanbtn {
        width: 100%;
        text-align: center;
        height: 40px;
        background-color: red;
        color: #ffffff;
    }

    .jisuanje {
        width: 90%;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 13px;
        height: 43px;
        line-height: 50px;
        border-bottom: #EEEEEE solid 1px;
    }

    .jisuanfs {
        width: 90%;
        margin: auto;
        font-size: 13px;
        padding-top: 10px;
    }

    .radio-btn {
        height: 30px;
        font-size: 13px;
    }

    ::v-deep .van-radio__icon {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -ms-flex: none;
        flex: none;
        height: 1em;
        font-size: 13px;
        line-height: 1em;
        cursor: pointer;
        position: absolute;
        right: 30px;
    }


    .card-emps {
        margin-top: 15px;
    }

    .card-emp-bt {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: 23px;
        line-height: 23px;
    }

    .card-emp-bt span {
        width: 50%;
        font-size: 13px;

    }

    .card-emp {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: 38px;
        line-height: 45px;
        border-bottom: #EEEEEE solid 1px;
    }

    .card-emp span {
        width: 50%;
        font-size: 13px;

    }
</style>
